// extracted by mini-css-extract-plugin
export var chip = "_4j-0";
export var filterDropdown = "_4j-5";
export var filterItem = "_4j-6";
export var icon = "_4j-1";
export var removeButton = "_4j-3";
export var removeIcon = "_4j-4";
export var separator = "_4j-2";